import * as Yup from 'yup';

export const validationScheme = () =>
    Yup.object().shape({
        product_type: Yup.string().required('Выберите тип продукта'),
        total_weight: Yup.number()
            .max(1000, 'Общий вес не может быть больше тысячи')
            .min(0, 'Общий вес не может быть меньше нуля'),
        item_count: Yup.number().min(0, 'Количество РПО в заявке не может быть меньше нуля'),
    });
